module.exports = __webpack_public_path__ + "2af23e60b067874a1f548bf969471183.svg";